import { TimeInput } from 'browser/components/atomic-elements/atoms/input/time-input'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const TimeField = LabelFieldFactory({ InputComponent: TimeInput })
export {TimeField}
